import groupBy from "lodash/groupBy";
import mapValues from "lodash/mapValues";

import { HETomm } from "../buildsteps/FlightCaseBlueprintCalculator";
import { Covers } from "../enum/Covers";
import { InteriorType } from "../enum/InteriorType";
import { LTCaseUserOption } from "../enum/LTCaseUserOption";
import { RackCoverPaddingStyle } from "../enum/RackCoverPaddingStyle";
import type { CoverPaddingSettings } from "../interfaces/CoverPaddingSettings";
import type { CutProperties } from "../interfaces/CutProperties";
import type { Rack19InteriorOptions } from "../interfaces/Rack19InteriorOptions";
import type { RackInteriorOptions } from "../interfaces/RackInteriorOptions";
import type { RackRailType } from "../interfaces/RackRailType";
import type { TrayMaterialType } from "../interfaces/TrayMaterialType";
import { OptionDBInstance } from "../user_options/options_db";

export type RackWidth19InchType = 465;
export const RackWidth19Inch: RackWidth19InchType = 465;

export const createCoverOptions = (
  cuts: CutProperties[],
  areaPaddingType = "nopad",
  borderPaddingType = "nopad",
): { [groupName: string]: CoverPaddingSettings } => {
  //    return _(cuts)
  //        .groupBy("groupName")
  //        .mapValues<CutProperties[], CoverPaddingSettings>((): CoverPaddingSettings => {
  //            return {
  //                areaPaddingStyle: RackCoverPaddingStyle.FULL,
  //                areaPaddingType: OptionDBInstance.getByName(LTCaseUserOption.PaddingType, areaPaddingType),
  //                borderPaddingType: OptionDBInstance.getByName(LTCaseUserOption.PaddingType, borderPaddingType),
  //                uuid: uuidv4(),
  //                width: 0,
  //            };
  //        })
  //        .value();

  return mapValues(
    groupBy(cuts, "groupName"),
    (): CoverPaddingSettings => ({
      areaPaddingStyle: RackCoverPaddingStyle.FULL,
      areaPaddingType: OptionDBInstance.getByName(
        LTCaseUserOption.PaddingType,
        areaPaddingType,
      ),
      borderPaddingType: OptionDBInstance.getByName(
        LTCaseUserOption.PaddingType,
        borderPaddingType,
      ),
      uuid: crypto.randomUUID(),
      width: 0,
    }),
  );
};

export const createRack19Interior = (
  rackUnits = 10,
  depth = 500,
  panelStrength = 9,
): Rack19InteriorOptions => {
  const rackRails = OptionDBInstance.getByName<RackRailType>(
    LTCaseUserOption.RackRailType,
    "M6162",
  );
  return {
    depth,
    height: HETomm(rackUnits),
    rackRailDisabled: {
      [Covers.FRONT_COVER]: false,
    },
    rackRailOffsets: {
      [Covers.TOP_COVER]: 0,
    },
    rackRails,
    standupRackRailOnTop: false,
    standupRackRails: rackRails,
    type: InteriorType.RACK19,
    underlayStrength: rackRails.forceUnderlayStrength || 15.5 - panelStrength,
    upperPaddingAlignment: false,
    width: RackWidth19Inch,
  };
};

export const createRackInterior = (
  height = 400,
  depth = 500,
  width = 500,
): RackInteriorOptions => {
  return {
    depth,
    heights: [height],
    rackCoverPaddings: {},
    trayMaterial: OptionDBInstance.getOrThrow<TrayMaterialType>(
      LTCaseUserOption.TrayMaterialType,
      {
        strength: 18,
      },
    ),
    type: InteriorType.RACK,
    upperPaddingAlignment: false,
    width,
    widths: [[width]],
  };
};
